export const VENDOR_LIST = "GAMES_VENDOR_LIST";
export const GAME_LIST = "GAMES_GAME_LIST";
export const GAMES_GAME_ACCESS = "GAMES_GAME_ACCESS";